<template>
  <section class="modal">
    <div class="box__modal" id="box__modal">
      <div class="header__modal">
        <span class="name__projet">{{ projet.title }}</span>
        <span @click="closeModale" class="close__modal">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            width="30"
            height="30"
          >
            <path
              fill-rule="evenodd"
              d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
              clip-rule="evenodd"
            />
          </svg>
        </span>
      </div>

      <div class="body__modal">
        <p>
          {{ projet.description }}
        </p>
      </div>
      <a class="link__projet" :href="projet.link">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          width="20"
          height="20"
        >
          <path
            fill-rule="evenodd"
            d="M19.902 4.098a3.75 3.75 0 00-5.304 0l-4.5 4.5a3.75 3.75 0 001.035 6.037.75.75 0 01-.646 1.353 5.25 5.25 0 01-1.449-8.45l4.5-4.5a5.25 5.25 0 117.424 7.424l-1.757 1.757a.75.75 0 11-1.06-1.06l1.757-1.757a3.75 3.75 0 000-5.304zm-7.389 4.267a.75.75 0 011-.353 5.25 5.25 0 011.449 8.45l-4.5 4.5a5.25 5.25 0 11-7.424-7.424l1.757-1.757a.75.75 0 111.06 1.06l-1.757 1.757a3.75 3.75 0 105.304 5.304l4.5-4.5a3.75 3.75 0 00-1.035-6.037.75.75 0 01-.354-1z"
            clip-rule="evenodd"
          />
        </svg>
        Démo
      </a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    projet: Object,
  },

  methods: {
    closeModale() {
      this.$store.commit("setDisplayModal", false);
    },
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.685);
  z-index: 999;
}

.box__modal {
  width: 50%;
  background: var(--body-color-1);
  color: var(--text-color);
  padding: 1rem 0.5rem;
  border-radius: 0.75rem;
  margin: 0 0.25rem;
  font-size: 18px;
  border-top: 5px solid var(--first-color);
}

/* @keyframes view {
  to{
    opacity: .9;
  }

  from{
    opacity: 1;
  }
  
} */

@media screen and (max-width: 730px) {
  .box__modal {
    width: 99%;
  }
}

.header__modal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  font-weight: 600;
}

.header__modal span svg {
  fill: var(--first-color);
  cursor: pointer;
}

.body__modal {
  max-height: 200px;
  overflow: auto;
  margin-bottom: 1rem;
}

.link__projet {
  width: max-content;
  display: flex;
  align-items: center;
  color: var(--first-color);
  column-gap: 4px;
}
</style>